import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { NumberDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { RemoveHrefDirective } from '@frontend/sports/navigation/core/feature/remove-href';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { DsTouchClickDirective } from '@frontend/ui/shared';
import { PlainLinkComponent } from '@frontend/vanilla/core';

import { OutrightTileData } from './marquee-tile.model';
import { MarqueeTrackingService } from './marquee-tracking.service';
import { OptionGroupComponent } from './option-group/option-group.component';

@Component({
    selector: 'ms-outrights-marquee-card',
    templateUrl: './outrights-marquee-card.component.html',
    imports: [PlainLinkComponent, DsTouchClickDirective, RemoveHrefDirective, NgOptimizedImage, NgTemplateOutlet, OptionGroupComponent],
})
export class OutrightsMarqueeCardComponent {
    private marqueeTrackingService = inject(MarqueeTrackingService);
    private urlHelper = inject(UrlHelperService);

    @Input() tile: OutrightTileData;
    @Input() textColor?: string;
    @Input() outrightOptionGroup: NumberDictionary<EventOptionGroup>;
    @Input() event: EventModel;
    @Input() backgroundImage?: string;
    @Input() globalLink: string;
    shouldRemoveHref: boolean;

    constructor() {
        this.shouldRemoveHref = this.urlHelper.shouldRemoveHref();
    }

    trackOutrightClicks(index: number, globalLink: string, sportId: number, competitionId: number, backgroundImage?: string): void {
        this.marqueeTrackingService.trackOutrightClicks(index, globalLink, sportId, competitionId, backgroundImage);
    }
}
